import Trade from './ABI/trade.json';


const contractProvider = {
    
    contractConnection: async (data) => {
        try{
            let web3 = data?.web3, abi = data?.abi, contractAddress = data?.contractAddress ;
        
            console.log('web3',web3)
            if (web3) {
                var contract_value = await new web3.eth.Contract(
                    abi,
                    contractAddress
                );
                return contract_value;
            }
        }
        catch(err){
            console.log('contractConnection_error',err);
        }
    },

    getReceipt: async (web3, hash) => {
        try {
            console.log('lksjkgljskljgdinnnnn', web3, hash)
            let receipt = await web3.eth.getTransactionReceipt(hash)
            console.log("receip1111111111111t", receipt)
            return receipt
        }
        catch (err) {
            console.log('getReceipt_error', err)
        }
    },

    completeDeposit: async (data) => {
        console.log('completeDeposit',data)
        try {
            let accountAddress = data?.accountAddress, amount = data?.amount, web3 = data?.web3, contractAddress= data?.contractAddress, depositUniqueId = data?.depositUniqueId, completeFullAmount= data?.completeFullAmount, withdrawAddress = data?.withdrawAddress ;
            let contractObject = await contractProvider.contractConnection({abi: Trade, contractAddress: contractAddress, web3: web3, })
            console.log('completesssss',data,contractObject)
            let hash = await contractObject.methods.complete(
                depositUniqueId,
                withdrawAddress,
                amount,
                completeFullAmount,
            ).send({
                from: accountAddress,
            })
            return await contractProvider.getReceipt(web3,hash?.transactionHash);
        } 
        catch (error) {
            console.log('completeDeposit_error',error)
            return {
                error: true,
                errorMessage: error?.message,
            }
        }
    }

}



export default contractProvider;